// A finite, bundled rotation. Sources and transcription notes are in
// `daily-quotes-sources.md`; no source is contacted at runtime.

export interface DailyQuote {
  text: string;
  speaker: string;
}

export const DAILY_QUOTES: readonly DailyQuote[] = [
  {
    text: 'If there is no struggle, there is no progress.',
    speaker: 'Frederick Douglass',
  },
  {
    text: 'However mean your life is, meet it and live it; do not shun it and call it hard names.',
    speaker: 'Henry David Thoreau',
  },
  {
    text: 'Where tireless striving stretches its arms towards perfection.',
    speaker: 'Rabindranath Tagore',
  },
  {
    text: 'Courage is the price that Life exacts for granting peace.',
    speaker: 'Amelia Earhart',
  },
  {
    text: 'Victory awaits him who has everything in order—luck, people call it.',
    speaker: 'Roald Amundsen',
  },
  {
    text: 'The moral fight possessed immense attraction for me.',
    speaker: 'Elizabeth Blackwell',
  },
  {
    text: 'The lure of the Arctic is tugging at my heart, to me the trail is calling!',
    speaker: 'Matthew A. Henson',
  },
  {
    text: 'The reward of labour is life. Is that not enough?',
    speaker: 'William Morris',
  },
  {
    text: 'For action is indeed the sole medium of expression for ethics.',
    speaker: 'Jane Addams',
  },
  {
    text: 'Keep on advancing. Learn, learn and think much about what you learn.',
    speaker: 'José Rizal',
  },
  {
    text: 'The only question left to be settled, now, is: Are women persons?',
    speaker: 'Susan B. Anthony',
  },
  {
    text: 'Keep for your ambition the determination to make a permanent contribution to science.',
    speaker: 'Marie Curie',
  },
  {
    text: 'The progressive development of man is vitally dependent on invention.',
    speaker: 'Nikola Tesla',
  },
  {
    text: 'A new, a vast, and a powerful language is developed for the future use of analysis.',
    speaker: 'Ada Lovelace',
  },
  {
    text: 'Nothing is too wonderful to be true, if it be consistent with the laws of nature.',
    speaker: 'Michael Faraday',
  },
  {
    text: 'The occasion is piled high with difficulty, and we must rise with the occasion.',
    speaker: 'Abraham Lincoln',
  },
  {
    text: 'I have always turned a bold front to fortune.',
    speaker: 'Mary Seacole',
  },
  {
    text: 'And so, lifting as we climb, onward and upward we go.',
    speaker: 'Mary Church Terrell',
  },
  {
    text: 'Oh, earnest hearts! Toil on in hope, till darkness shrinks from light.',
    speaker: 'Frances Ellen Watkins Harper',
  },
  {
    text: 'Truth is mighty and will prevail.',
    speaker: 'Ida B. Wells',
  },
  {
    text: 'The art of life lies in a constant readjustment to our surroundings.',
    speaker: 'Kakuzō Okakura',
  },
  {
    text: 'Work is love made visible.',
    speaker: 'Kahlil Gibran',
  },
  {
    text: 'Optimism is the faith that leads to achievement; nothing can be done without hope.',
    speaker: 'Helen Keller',
  },
  {
    text: 'Truth, then, is the source and foundation of all things that are good and great.',
    speaker: 'Mahatma Gandhi',
  },
  {
    text: 'The cause of freedom is not the cause of a race or a sect, a party or a class.',
    speaker: 'Anna Julia Cooper',
  },
  {
    text: 'The dream of yesterday is the hope of today and the reality of tomorrow.',
    speaker: 'Robert H. Goddard',
  },
  {
    text: 'The best prize that life offers is the chance to work hard at work worth doing.',
    speaker: 'Theodore Roosevelt',
  },
  {
    text: 'If I can stop one heart from breaking, I shall not live in vain.',
    speaker: 'Emily Dickinson',
  },
  {
    text: 'The worker must work for the glory of his handiwork, not simply for pay.',
    speaker: 'W. E. B. Du Bois',
  },
];
